// src/components/Auth/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = () => {
  const { currentUser, isLoading, canAccessRoute } = useAuth();
  const location = useLocation();
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-indigo-500" />
      </div>
    );
  }
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (location.pathname === '/onboarding') {
    return <Outlet />;
  }
  
  // Use canAccessRoute from AuthContext which uses allowedModules
  if (!canAccessRoute(location.pathname)) {
    // If user can't access this route, redirect to dashboard if they have access, otherwise first allowed route
    return <Navigate to="/" replace />;
  }
  
  return <Outlet />;
};

export default ProtectedRoute;
